// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gW","advertCardHeader__actions":"c-a_gX","advertCardHeader__bottomLabel":"c-a_gY"};